
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_1i0s3_khky8_9",
  "header": "awsui_header_1i0s3_khky8_41",
  "content": "awsui_content_1i0s3_khky8_45",
  "error": "awsui_error_1i0s3_khky8_49",
  "footer": "awsui_footer_1i0s3_khky8_53",
  "actions-section": "awsui_actions-section_1i0s3_khky8_57",
  "secondary-actions": "awsui_secondary-actions_1i0s3_khky8_66",
  "actions": "awsui_actions_1i0s3_khky8_57"
};
  